import { TaskStartDatePeriod } from "Models/task";

export const PERIOD_BUFFER_TIME = {
  [TaskStartDatePeriod.MORNING]: { hours: 6 },
  [TaskStartDatePeriod.AFTERNOON]: { hours: 6 },
  [TaskStartDatePeriod.EVENING]: { hours: 6 },
  [TaskStartDatePeriod.FULL_DAY]: { hours: 12 },
  [TaskStartDatePeriod.CUSTOM]: { hours: 1 },
  [TaskStartDatePeriod.MULTI_DAY]: { days: 1 },
  [TaskStartDatePeriod.VARIABLE_TIME]: { hours: 1 },
  [TaskStartDatePeriod.FIXED_TIME]: { hours: 1 },
};
